import { get, set } from 'lib/storage/isomorphicSessionStorage'

const keyFor = (memberId: string, chatId: number) => `tripPlanner:spoofSendConfirmed:${memberId}:${chatId}`

export function hasConfirmedSpoofSend(memberId: string, chatId: number): boolean {
  return get(keyFor(memberId, chatId)) === true
}

export function markSpoofSendConfirmed(memberId: string, chatId: number): void {
  set(keyFor(memberId, chatId), true)
}
